import { Link } from 'gatsby';
import React, { ReactNode } from 'react';
import config from '../../config';

interface IProps {
    link: string;
    className?: string;
    children: ReactNode;
    onClick?: () => void;
    useATag?: boolean;
}

export default function NavbarLink(props: IProps) {
    const isTeamSubdomain = typeof location !== 'undefined' && config.isTeamSubdomainPage(location);

    if (isTeamSubdomain) {
        return (
            <a href={`https://biolib.com${props.link}`} className={props.className} onClick={props.onClick}>
                {props.children}
            </a>
        );
    }

    if (props.useATag) {
        return (
            <a href={props.link} className={props.className} onClick={props.onClick}>
                {props.children}
            </a>
        );
    }

    return (
        <Link to={props.link} className={props.className} onClick={props.onClick}>
            {props.children}
        </Link>
    );
}
